import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./SearchModal.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const SearchModal = ({ searchQuery, setSearchQuery, results, onSelect, onClose }) => {
  // Close modal on ESC key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {/* Search Box */}
        <div className={styles.searchBox}>
          <div className={styles.searchIcon}>
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </div>
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            autoFocus
          />
        </div>

        {/* Search Results */}
        {results.length > 0 && (
          <div className={styles.searchResults}>
            {results.map((item) => (
              <div
                key={item.id}
                className={styles.searchResultItem}
                onClick={() => onSelect(item.service, item.title, item.id)}
              >
                {item.title}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>,
    document.getElementById("portal-root") // make sure you add this div in index.html
  );
};

export default SearchModal;
